import { render, staticRenderFns } from "./DashboardAxerta.vue?vue&type=template&id=e7eef964&scoped=true"
import script from "./DashboardAxerta.vue?vue&type=script&lang=js"
export * from "./DashboardAxerta.vue?vue&type=script&lang=js"
import style0 from "./DashboardAxerta.vue?vue&type=style&index=0&id=e7eef964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7eef964",
  null
  
)

export default component.exports